//====================================================
//  Initialization Slider
//====================================================
function fn_components_slider(){
    fn_main_slider();
    fn_small_slider();
    fn_detail_slider();
    fn_partners_slider();
}

function fn_main_slider(){
    if ($('.slider').length) {

        var $status = $('.paging-info');
        var $slickElement = $('.slider');

        $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
            var i = (currentSlide ? currentSlide : 0) + 1;
            $status.find('.actual-slide').text('0' + i);
            $status.find('.value').text('0' + slick.slideCount);
        });

        $('.slider').slick({
            infinite: true,
            dots: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            autoplay: true,
            variableWidth: false,
            nextArrow: '<span class="slick-arrows slick-next"><i class="icon icon-download-arrow"></i></span>',
            prevArrow: '<span class="slick-arrows slick-prev"><i class="icon icon-up-arrow"></i></span>',
            mobileFirst: true
        });
    }
}


function fn_small_slider(){
    if ($('.slider-small').length) {
        $('.slider-small').slick({
            infinite: true,
            dots: false,
            speed: 500,
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 2000,
            cssEase: 'ease',
            variableWidth: false,
            nextArrow: '<span class="slick-arrows slick-next"><i class="icon icon-right-arrow"></i></span>',
            prevArrow: '<span class="slick-arrows slick-prev"><i class="icon icon-left-arrow"></i></span>',
            mobileFirst: true,
            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 6,
                    slidesToScroll: 1,
                  }
                },
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                  }
                }
            ]
        });
    }

}


function fn_partners_slider(){
    if ($('.partners-section').length) {
        $('.partners').slick({
            infinite: true,
            dots: false,
            speed: 500,
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 2000,
            cssEase: 'ease',
            variableWidth: false,
            mobileFirst: true,
            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 6,
                    slidesToScroll: 3,
                  }
                },
                {
                  breakpoint: 800,
                  settings: {
                    slidesToShow: 4,
                    slidesToScroll: 2,
                  }
                },
                {
                  breakpoint: 500,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                  }
                }
            ]
        });
    }

}


function fn_detail_slider(){
    if ($('.gallery-slider').length) {
        $('.gallery-slider').slick({
            infinite: true,
            dots: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 2000,
            cssEase: 'ease',
            variableWidth: false,
            nextArrow: '<span class="slick-arrows slick-next"><i class="icon icon-right-arrow"></i></span>',
            prevArrow: '<span class="slick-arrows slick-prev"><i class="icon icon-left-arrow"></i></span>',
            mobileFirst: true,
            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                  }
                },
                {
                  breakpoint: 769,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                  }
                }
            ]
        });
    }

}
